'use strict';

/**
 * Converts a string to snake case.
 * Snake case is a naming convention where each space or non-alphanumeric character is replaced with an underscore (_),
 * and all letters are converted to lowercase.
 *
 * @param str - The string to convert to snake case.
 * @returns The snake case representation of the input string.
 */ function toSnakeCase(str) {
    var _str_match;
    return ((_str_match = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) != null ? _str_match : []).join('_').toLowerCase();
}

module.exports = toSnakeCase;
